import { fetchLatestInventoryUnitsCSV } from 'src/services/client';

const UseFetchInventoryUnitsForExport = () => {
  const retrieveLatestInventoryUnitsFromAPI = async (propertyId: number) => {
    try {
      const csvString: string = await fetchLatestInventoryUnitsCSV(propertyId);

      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      const timestamp = new Date().toISOString().split('T')[0];
      const filename = `suite-export-${propertyId}-${timestamp}.csv`;

      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Unexpected error in retrieveLatestInventoryUnitsFromAPI', error);
      throw error;
    }
  };

  return {
    retrieveLatestInventoryUnitsFromAPI
  };
};

export default UseFetchInventoryUnitsForExport;